module.exports = "/static/assets/2d57c5f59e4b5349e0f01c11e4ff46e3.gif";